(function(){
  window.dataLayer = window.dataLayer || [];
  if (!window.__mcWrapInstalled) {
    window.__mcWrapInstalled = true;
    const __origPush = window.dataLayer.push.bind(window.dataLayer);

    window.dataLayer.push = function(payload){
      try {
        if (payload && payload.event === 'select_promotion') {
          const btnState = window.__mcPromotionState; // 'Main CTA - Open' | 'Main CTA - Close' | 'Main CTA - <Item>'
          if (btnState) {
            if (payload.promotions && !Array.isArray(payload.promotions)) {
              payload.promotions = Object.assign({}, payload.promotions, { promotionButton: btnState });
            } else if (Array.isArray(payload.promotions)) {
              payload.promotions = payload.promotions.map(p => Object.assign({}, p, { promotionButton: btnState }));
            }
          }
        }
      } catch(e){}
      return __origPush(payload);
    };
  }

  // Helpers
  function setPromotionOpen(){  window.__mcPromotionState = 'Main CTA - Open'; }
  function setPromotionClose(){ window.__mcPromotionState = 'Main CTA - Close'; }
  function setPromotionItemLabel(el){
    const raw = el.getAttribute('data-analytics-label') 
             || el.getAttribute('aria-label') 
             || el.textContent 
             || '';
    const label = raw.trim().replace(/\s+/g,' ');
    if (label) window.__mcPromotionState = `Main CTA - ${label}`;
  }

  document.addEventListener('pointerdown', function(e){
    const trigger = e.target.closest('.mc-trigger');
    if (trigger) {
      const root = trigger.closest('.mc-root');
      const willOpen = !root?.hasAttribute('data-open');
      willOpen ? setPromotionOpen() : setPromotionClose();
      return;
    }
    if (e.target.matches('[data-mc-close]')) {
      setPromotionClose();
      return;
    }

    const item = e.target.closest('.mc-item, .mc-sheet__item');
    if (item) {
      setPromotionItemLabel(item);
      return;
    }

    const anyOpen = document.querySelector('.mc-root[data-open="true"]');
    if (anyOpen && !e.target.closest('.mc-root') && !e.target.closest('.mc-sheet__panel')) {
      setPromotionClose();
    }
  }, { capture: true });

  document.addEventListener('keydown', function(e){
    if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.classList?.contains('mc-trigger')) {
      const root = e.target.closest('.mc-root');
      const willOpen = !root?.hasAttribute('data-open');
      willOpen ? setPromotionOpen() : setPromotionClose();
    }
    if ((e.key === 'Enter' || e.key === ' ') && e.target && (e.target.closest('.mc-item') || e.target.closest('.mc-sheet__item'))) {
      const item = e.target.closest('.mc-item, .mc-sheet__item');
      if (item) setPromotionItemLabel(item);
    }
    if (e.key === 'Escape' && document.querySelector('.mc-root[data-open="true"]')) {
      setPromotionClose();
    }
  }, { capture: true });

  const mq = window.matchMedia('(max-width: 768px)');

  function closeAll(except){
    document.querySelectorAll('.mc-root').forEach(root=>{
      if(root===except) return;
      root.removeAttribute('data-open');
      const trig=root.querySelector('.mc-trigger');
      const panel=root.querySelector('.mc-panel');
      const sheet=root.querySelector('.mc-sheet');
      trig && trig.setAttribute('aria-expanded','false');
      panel && panel.setAttribute('aria-hidden','true');
      if(sheet){ sheet.setAttribute('aria-hidden','true'); sheet.removeAttribute('data-open'); }
    });
  }

  function open(root){
    const isMobile = mq.matches;
    const trig=root.querySelector('.mc-trigger');
    const panel=root.querySelector('.mc-panel');
    const sheet=root.querySelector('.mc-sheet');

    closeAll(root);
    root.setAttribute('data-open','true');
    trig && trig.setAttribute('aria-expanded','true');
    if(isMobile){
      sheet && (sheet.setAttribute('data-open','true'), sheet.setAttribute('aria-hidden','false'));
    }else{
      panel && panel.setAttribute('aria-hidden','false');
    }
  }

  function close(root){
    const trig=root.querySelector('.mc-trigger');
    const panel=root.querySelector('.mc-panel');
    const sheet=root.querySelector('.mc-sheet');
    root.removeAttribute('data-open');
    trig && trig.setAttribute('aria-expanded','false');
    panel && panel.setAttribute('aria-hidden','true');
    sheet && (sheet.setAttribute('aria-hidden','true'), sheet.removeAttribute('data-open'));
  }

  document.addEventListener('click', (e)=>{
    const btn = e.target.closest('.mc-trigger');
    if(btn){
      const root = btn.closest('.mc-root');
      root.hasAttribute('data-open') ? close(root) : open(root);
      e.stopPropagation();
      return;
    }
    if(!e.target.closest('.mc-root') && !e.target.closest('.mc-sheet__panel')) closeAll();
    if(e.target.matches('[data-mc-close]')){
      const sheet = e.target.closest('.mc-sheet');
      const root = sheet?.closest('.mc-root');
      if(root) close(root);
    }
    const item = e.target.closest('.mc-item, .mc-sheet__item');
    if(item){
      const root = e.target.closest('.mc-root') || document.querySelector('.mc-root[data-open="true"]');
      if(root) close(root);
    }
  });

  document.addEventListener('keydown', (e)=>{ if(e.key==='Escape') closeAll(); });
})();
